export default "__VITE_ASSET__CI_h$SOH__"